import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  FDBodyText,
  FDDisplayText,
} from '@facet-wealth/design';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import { Layout } from './Layout';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDDisplayText,
    _customProps: {
      size: 'md',
    },
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => FDBodyText,
    _customProps: {
      size: 'md',
      align: 'center',
    },
  }, overrideReadOnly)
  .done();

const TaxWaitlistPage = ({ resource }) => {
  return (
    <MetaResourceRenderer
      layout={Layout}
      resource={resource}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

TaxWaitlistPage.defaultProps = {
};

TaxWaitlistPage.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export { TaxWaitlistPage };
